function AppSection() {
  return (
    <section id="app" className="scroll-mt-16 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 text-center mb-10">
          手机观映
        </h2>
        <div className="max-w-3xl mx-auto">
          <div className="flex flex-col md:flex-row items-center gap-8 p-6 md:p-10 bg-background-100 rounded-2xl border border-secondary-200/50">
            <div className="w-20 h-20 md:w-24 md:h-24 flex-shrink-0 rounded-2xl bg-accent-500/10 flex items-center justify-center">
              <i className="ri-smartphone-line text-4xl text-accent-500"></i>
            </div>
            <div className="flex-1 text-center md:text-left">
              <h3 className="font-heading text-xl text-foreground-900 mb-3">随时随地，畅享高清观影</h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-5">
                草民影院全面适配移动端，支持手机与平板设备流畅观影。1080P蓝光画质自适应网络环境，
                高清不卡顿，即点即看。无论通勤、休息还是旅途，打开手机就能享受影院级观影体验。
              </p>
              <div className="flex flex-wrap items-center justify-center md:justify-start gap-3">
                <span className="inline-flex items-center gap-1.5 px-4 py-2 bg-foreground-900 text-background-50 text-xs rounded-lg cursor-pointer whitespace-nowrap">
                  <i className="ri-android-line"></i> Android 版
                </span>
                <span className="inline-flex items-center gap-1.5 px-4 py-2 bg-foreground-900 text-background-50 text-xs rounded-lg cursor-pointer whitespace-nowrap">
                  <i className="ri-apple-line"></i> iOS 版
                </span>
                <span className="text-xs text-foreground-500">或直接浏览器访问</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function AboutSection() {
  return (
    <section id="about" className="scroll-mt-16 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 text-center mb-10">
          关于草民
        </h2>
        <div className="max-w-4xl mx-auto">
          <div className="flex flex-col md:flex-row gap-8 items-center">
            <div className="flex-1">
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                草民影院致力于为影迷打造<strong>高清电影与超清电视剧</strong>的一站式在线观影平台。
                我们深知画质对于观影体验的重要性，因此平台全线内容均支持
                <strong>1080P蓝光画质</strong>在线播放。
              </p>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                依托高效的内容分发与智能缓冲技术，草民影院实现了<strong>高清不卡、流畅不缓冲</strong>的观影体验。
                无论网络环境如何变化，我们始终将流畅度放在首位，让每一位用户都能<strong>即点即看</strong>。
              </p>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                平台内容覆盖动作、悬疑、喜剧、科幻、爱情、纪录片等全类型，每日更新热门影片与经典佳作。
                草民影院，用心服务每一位热爱电影的你。
              </p>
            </div>
            <div className="w-48 h-48 md:w-56 md:h-56 flex-shrink-0 rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20cinematic%20clapperboard%20icon%20with%20golden%20glow%2C%20minimalist%20design%2C%20rich%20amber%20and%20cream%20tones%2C%20soft%20theatrical%20lighting%2C%20elegant%20simple%20composition%2C%20no%20text%2C%20high%20detail%2C%20clean%20background&width=600&height=600&seq=about-logo-01&orientation=squarish"
                alt="草民影院品牌形象"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function MediaSection() {
  const items = [
    {
      title: '《暗影追踪》',
      tag: '动作 · 悬疑',
      desc: '影片以其凌厉的剪辑与饱满的叙事，为观众呈现了一场酣畅淋漓的视听追凶之旅。1080P蓝光画质下每一帧都极具张力。',
      img: 'https://readdy.ai/api/search-image?query=Cinematic%20action%20thriller%20film%20scene%20with%20dramatic%20warm%20lighting%2C%20noir%20cityscape%20at%20dusk%2C%20golden%20street%20lamps%2C%20film%20grain%20texture%2C%20movie%20poster%20aesthetic%2C%20rich%20amber%20and%20shadow%20tones%2C%20no%20text%2C%20cinematic%20composition&width=800&height=500&seq=media-01&orientation=landscape',
    },
    {
      title: '《夏日回响》',
      tag: '剧情 · 爱情',
      desc: '一段跨越十年的情感旅程，在柔和的光影与细腻的镜头语言中缓缓展开。超清电视剧级别的叙事质感令人沉醉。',
      img: 'https://readdy.ai/api/search-image?query=Emotional%20drama%20romance%20film%20scene%20with%20soft%20warm%20sunset%20lighting%2C%20golden%20hour%20glow%20in%20countryside%2C%20cinematic%20shallow%20depth%20of%20field%2C%20amber%20and%20soft%20brown%20tones%2C%20film%20poster%20style%2C%20no%20text%2C%20romantic%20mood&width=800&height=500&seq=media-02&orientation=landscape',
    },
    {
      title: '《星际迷航：新纪元》',
      tag: '科幻 · 冒险',
      desc: '浩瀚宇宙中的壮丽冒险，震撼的视觉特效在1080P蓝光画质下展现令人窒息的太空奇观，高清不卡顿的流畅体验让沉浸感倍增。',
      img: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20space%20adventure%20scene%20with%20warm%20nebula%20glow%2C%20spaceship%20silhouette%20against%20golden%20starfield%2C%20cinematic%20wide%20shot%2C%20rich%20amber%20and%20deep%20space%20tones%2C%20movie%20poster%20aesthetic%2C%20no%20text%2C%20atmospheric&width=800&height=500&seq=media-03&orientation=landscape',
    },
  ];

  return (
    <section id="media" className="scroll-mt-16 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 text-center mb-10">
          精选推荐
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {items.map((item) => (
            <div key={item.title} className="group bg-background-100 rounded-xl overflow-hidden border border-secondary-200/40 hover:border-secondary-300/60 transition-colors cursor-pointer">
              <div className="aspect-video overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <span className="inline-block text-xs font-medium text-accent-600 bg-accent-50/80 px-2.5 py-1 rounded-md mb-3">
                  {item.tag}
                </span>
                <h3 className="font-heading text-lg text-foreground-900 mb-2">{item.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function UpdatesSection() {
  const updates = [
    { date: '2026-07-30', title: '《星际迷航：新纪元》蓝光版本上线', tag: '新片速递' },
    { date: '2026-07-28', title: '暑期档专题「燃夏大片」火热更新中', tag: '专题' },
    { date: '2026-07-26', title: '平台画质全面升级至1080P蓝光标准', tag: '公告' },
    { date: '2026-07-24', title: '《暗影追踪》口碑爆棚，评分突破9.2', tag: '热映' },
    { date: '2026-07-21', title: '悬疑剧场「迷雾剧场」第六季开播', tag: '剧集' },
    { date: '2026-07-19', title: '移动端观影体验优化，加载速度提升40%', tag: '优化' },
    { date: '2026-07-17', title: '经典重映「黄金时代」专题上线', tag: '专题' },
    { date: '2026-07-15', title: '《夏日回响》续集已确认制作中', tag: '资讯' },
  ];

  return (
    <section id="updates" className="scroll-mt-16 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 text-center mb-10">
          最新动态
        </h2>
        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 border-l-2 border-secondary-200">
            {updates.map((update, idx) => (
              <div key={idx} className="relative mb-8 last:mb-0">
                <div className="absolute -left-[calc(2rem+5px)] top-1 w-2.5 h-2.5 rounded-full bg-primary-500 ring-4 ring-background-100"></div>
                <div className="flex flex-wrap items-center gap-2 mb-1.5">
                  <span className="text-xs text-foreground-500">{update.date}</span>
                  <span className="text-xs px-2 py-0.5 bg-accent-100/80 text-accent-700 rounded-md font-medium">
                    {update.tag}
                  </span>
                </div>
                <p className="text-sm md:text-base text-foreground-800 font-medium">{update.title}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

function CarouselSection() {
  const topics = [
    {
      title: '燃夏大片特辑',
      desc: '精选暑期最热动作、科幻与冒险影片，每一部都值得在1080P蓝光画质下细细品味。',
      img: 'https://readdy.ai/api/search-image?query=Summer%20blockbuster%20movie%20collage%20with%20warm%20golden%20lighting%2C%20explosive%20action%20scenes%2C%20cinematic%20composition%2C%20rich%20amber%20and%20orange%20tones%2C%20film%20poster%20aesthetic%2C%20no%20text%2C%20dynamic%20mood&width=800&height=500&seq=carousel-01&orientation=landscape',
    },
    {
      title: '悬疑之夜',
      desc: '烧脑神作云集，从经典推理到心理惊悚，高清画质让每一处细节都成为破案关键。',
      img: 'https://readdy.ai/api/search-image?query=Mystery%20thriller%20film%20noir%20scene%20with%20dramatic%20shadow%20and%20warm%20light%2C%20rainy%20city%20street%20at%20night%2C%20golden%20street%20lamp%20glow%2C%20cinematic%20composition%2C%20rich%20amber%20and%20dark%20tones%2C%20no%20text&width=800&height=500&seq=carousel-02&orientation=landscape',
    },
    {
      title: '经典重映计划',
      desc: '那些年错过的影史经典，现在以修复版1080P蓝光画质重新呈现，即点即看。',
      img: 'https://readdy.ai/api/search-image?query=Classic%20vintage%20cinema%20scene%20with%20warm%20nostalgic%20glow%2C%20old%20film%20projector%20with%20golden%20light%20beam%2C%20retro%20movie%20theater%20atmosphere%2C%20amber%20and%20sepia%20tones%2C%20no%20text%2C%20elegant%20composition&width=800&height=500&seq=carousel-03&orientation=landscape',
    },
    {
      title: '高分剧集联播',
      desc: '豆瓣9分以上超清电视剧一次看够，不卡顿不缓冲，周末追剧的最佳伴侣。',
      img: 'https://readdy.ai/api/search-image?query=Cozy%20home%20TV%20series%20binge-watching%20scene%20with%20warm%20lamp%20light%2C%20soft%20blanket%20on%20couch%2C%20golden%20ambient%20glow%2C%20cinematic%20cozy%20atmosphere%2C%20rich%20amber%20and%20cream%20tones%2C%20no%20text%2C%20comfortable%20mood&width=800&height=500&seq=carousel-04&orientation=landscape',
    },
  ];

  return (
    <section id="carousel" className="scroll-mt-16 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 text-center mb-10">
          热门专题
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {topics.map((topic) => (
            <div
              key={topic.title}
              className="group bg-background-100 rounded-xl overflow-hidden border border-secondary-200/40 hover:border-secondary-300/60 transition-colors cursor-pointer flex flex-col"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={topic.img}
                  alt={topic.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5 flex-1 flex flex-col">
                <h3 className="font-heading text-base text-foreground-900 mb-2">{topic.title}</h3>
                <p className="text-xs text-foreground-600 leading-relaxed flex-1">{topic.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default function SectionsA() {
  return (
    <>
      <AppSection />
      <AboutSection />
      <MediaSection />
      <UpdatesSection />
      <CarouselSection />
    </>
  );
}